import React from "react"
import styles from "./NewTask.module.scss"
import create_task_svg from "../../Components/icons/create_task.svg";
import Task from "../Task/Task";



class NewTask extends React.Component {
    state = {
        openNew: false
    }
    back_button = () => {
        this.setState({
            openNew: false
        })
    }
    render() {
        const ren = this.state.openNew ? <Task resetInfo={this.props.resetInfo} toggleImplement={this.props.toggleImplement}  implementName={this.props.implementName} implementSrc={this.props.implementSrc} name={this.props.name} color={this.props.color}  toggleTracktor={this.props.toggleTracktor} focusZone={this.props.focusZone} back_button={this.back_button}></Task> : <div style={{   

        }}>
            <p className={styles.new_task_text}>Tasks</p>
            <div style={{
                width:"100%",
                display: "flex",
                flexDirection: "column",
                marginTop: "50%",
                alignItems: "center",
               
            }}>
                <img src={create_task_svg} alt="Notes" />
                <p className={styles.no_tasks}>No tasks created yet</p>
            </div>

            <button onClick={() => {
                this.setState({
                    openNew: true
                })
            }} className={styles.new_task_btn}>
                Create New Task
          </button>
            <button onClick={() => { }}
                className={styles.new_mission_btn}>
                Set New Mission
          </button>
        </div >
        return (
            ren

        );
    }
}

export default NewTask